<template>
  <div>
    <v-dialog
      v-model="data.dialogShow"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar class="elevation-1 green lighten-2">
          <v-btn flat icon @click="data.dialogShow = false">
            <font-awesome-icon icon="arrow-left" size="2x" class="black--text"/>
          </v-btn>

          <v-spacer></v-spacer>
          <v-toolbar-items></v-toolbar-items>
        </v-toolbar>
        <!-- -->
        <v-container fluid>
          <v-card class="mb-2 py-1 elevation-1 green lighten-5">
            <v-layout align-start justify-start row wrap>
              <v-flex md12>
                <v-btn color="light-blue" :loading="isLoadingSave" @click="onSave()">
                  <v-icon class="pr-2">save</v-icon>SAVE
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card>

          <v-card class="mb-3 py-3 elevation-1 green lighten-5">
            <v-layout align-start justify-start row wrap>
              <v-flex md6>
                <v-alert
                  class="ma-2"
                  dismissible
                  :value="alertValue"
                  :color="alertColor"
                  :icon="alertIcon"
                  outline
                >{{alertMessage}}</v-alert>
              </v-flex>
            </v-layout>

            <v-layout align-start justify-start row wrap>
              <v-flex md6>
                <v-layout align-start justify-start row wrap>
                  <v-flex md4 class="px-3 subHeading font-weight-medium">Kode</v-flex>
                  <v-flex
                    md8
                    class="px-3 subHeading font-weight-medium green--text darken-4"
                  >: {{data.code}}</v-flex>
                </v-layout>
                <v-layout align-start justify-start row wrap>
                  <v-flex md4 class="px-3 subHeading font-weight-medium">Nama</v-flex>
                  <v-flex
                    md8
                    class="px-3 subHeading font-weight-medium green--text darken-4"
                  >: {{data.name}}</v-flex>
                </v-layout>

                <v-layout align-start justify-start row wrap>
                  <v-flex md4 class="px-3 subHeading font-weight-medium">Keterangan</v-flex>
                  <v-flex
                    md8
                    class="px-3 subHeading font-weight-medium green--text darken-4"
                  >: {{data.description}}</v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card>

          <!-- -->
          <v-card class="mb-3 py-3 elevation-1 green lighten-5">
            <v-layout>
              <v-flex md6>
                <v-autocomplete
                  class="ml-2"
                  v-model="model"
                  :items="items"
                  :loading="isLoading"
                  :search-input.sync="search"
                  color="green"
                  background-color="green lighten-5"
                  hide-no-data
                  hide-selected
                  item-text="descriptionDisplay"
                  item-value="API"
                  label="Data Sub Aspek"
                  placeholder="Ketik untuk mencari"
                  prepend-icon="search"
                  return-object
                ></v-autocomplete>
              </v-flex>
              <v-flex md6>
                <v-btn color="indigo" outline @click="onAddSubAspec()">
                  <v-icon>add</v-icon>Tambah
                </v-btn>
                <v-btn color="indigo" outline @click="onClearAutoComplete()">
                  <v-icon>clear</v-icon>Clear
                </v-btn>
              </v-flex>
            </v-layout>

            <v-card class="mx-4 py-2 elevation-1 yellow lighten-5" v-if="model">
              <v-layout align-start justify-start row wrap>
                <v-flex md12>
                  <v-layout align-start justify-start row wrap>
                    <v-flex md1 class="px-3 subHeading font-weight-medium">Kode</v-flex>
                    <v-flex
                      md8
                      class="px-3 subHeading font-weight-medium green--text darken-4"
                    >: {{model.code}}</v-flex>
                  </v-layout>
                  <v-layout align-start justify-start row wrap>
                    <v-flex md1 class="px-3 subHeading font-weight-medium">Nama</v-flex>
                    <v-flex
                      md8
                      class="px-3 subHeading font-weight-medium green--text darken-4"
                    >: {{model.name}}</v-flex>
                  </v-layout>

                  <v-layout align-start justify-start row wrap>
                    <v-flex md1 class="px-3 subHeading font-weight-medium">Keterangan</v-flex>
                    <v-flex
                      md8
                      class="px-3 subHeading font-weight-medium green--text darken-4"
                    >: {{model.description}}</v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>

            <v-data-table
              :headers="dataSubAspec.headers"
              :items="dataSubAspec.items"
              class="elevation-0 ma-2"
              hide-actions
            >
              <template slot="items" slot-scope="props">
                <td class="text-xs-center">{{ props.index + 1}}</td>
                <td class="text-xs-center">
                  <v-btn
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="red darken-5"
                    small
                    @click="onRemoveSubAspec(props.index)"
                  >
                    <v-icon>delete</v-icon>
                  </v-btn>
                </td>
                <td class="text-xs-left">{{ props.item.code }}</td>
                <td class="text-xs-left">{{ props.item.tipe }}</td>
                <td class="text-xs-left">{{ props.item.name }}</td>
                <td class="text-xs-left">{{ props.item.description }}</td>
                <td></td>
              </template>
            </v-data-table>
          </v-card>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ApiService from "@/common/api.service";

export default {
  props: {
    data: Object
  },
  data: () => ({
    isLoadingSave: false,
    alertColor: "",
    alertIcon: "",
    alertValue: false,
    alertMessage: "",
    descriptionLimit: 60,
    entries: [],
    isLoading: false,
    model: null,
    search: null,
    dataSubAspec: {
      headers: [
        {
          text: "No",
          align: "center",
          sortable: false,
          value: "",
          width: "1%",
          class: "subheading font-weight-bold"
        },
        {
          text: "Action",
          align: "center",
          sortable: false,
          value: "",
          width: "1%",
          class: "subheading font-weight-bold"
        },
        {
          text: "Kode",
          align: "center",
          sortable: false,
          value: "code",
          width: "20%",
          class: "subheading font-weight-bold"
        },
         {
          text: "Tipe",
          align: "center",
          sortable: false,
          value: "code",
          width: "20%",
          class: "subheading font-weight-bold"
        },
        {
          text: "Nama",
          align: "center",
          sortable: false,
          value: "aspec",
          width: "20%",
          class: "subheading font-weight-bold"
        },
        {
          text: "Keterangan",
          align: "left",
          sortable: false,
          value: "aspecDetail",
          width: "70%",
          class: "subheading font-weight-bold"
        },
        {
          text: "",
          align: "center",
          sortable: false,
          value: "",
          width: "20%",
          class: "subheading font-weight-bold"
        }
      ],
      items: []
    }
  }),
  computed: {
    fields() {
      if (!this.model) return [];
      return Object.keys(this.model).map(key => {
        return {
          key,
          value: this.model[key] || "n/a"
        };
      });
    },
    items() {
      return this.entries.map(entry => {
        const descriptionDisplay =
          entry.description.length > this.descriptionLimit
            ? entry.code +
              " | " +
              entry.name +
              " | " +
              entry.description.slice(0, this.descriptionLimit) +
              "..."
            : entry.code + " | " + entry.name + " | " + entry.description;

        return Object.assign({}, entry, { descriptionDisplay });
      });
    }
  },
  updated() {
    if (this.data.firstLoad === true) {  
      const vm = this;
      ApiService.post("DataAspec/GetDataAspecSubAspecByAspecId", {
        DataAspecId: vm.data.dataAspecId
      })
        .then(response => {
          vm.dataSubAspec.items = response.data;
        })
        .catch(() => {})
        .finally(() => {
          vm.data.firstLoad = false;
        });
    }
  },

  watch: {
    search() {
      // Items have already been loaded
      if (this.items.length > 0) return;

      // Items have already been requested
      if (this.isLoading) return;

      const vm = this;
      vm.isLoading = true;
      ApiService.post("DataAspec/GetDataSubAspecAutoComplete", {
        // DataSubAspecId: vm.data.dataSubAspecId
      })
        .then(response => {
          const { count, entries } = response.data;
          vm.count = count;
          vm.entries = entries;
        })
        .catch()
        .finally(() => {
          vm.isLoading = false;
        });
    }
  },
  methods: {
    onSave: function() {
      const vm = this;
      vm.isLoadingSave = true;
      ApiService.post("DataAspec/UpdateDataAspecSubAspec", {
        DataAspecId: vm.data.dataAspecId,
        SubAspecs: vm.dataSubAspec.items
      })
        .then(() => {
          vm.$emit("close-window");

          vm.data.dialogShow = false;
        })
        .catch(({ response }) => {
          if (response.status == 400) {
            vm.alertColor = "warning";
            vm.alertIcon = "priority_high";
            vm.alertValue = true;
            vm.alertMessage = response.data;
          } else {
            vm.alertColor = "error";
            vm.alertIcon = "warning";
            vm.alertValue = true;
            vm.alertMessage = response.data;
          }
        })
        .finally(() => {
          vm.isLoadingSave = false;
        });
    },
    onRemoveSubAspec: function(rowIndex) {
      this.dataSubAspec.items.splice(rowIndex, 1);
    },
    onAddSubAspec: function() {
      const vm = this;
      let isExist = false;

      this.dataSubAspec.items.forEach(function(entry) {
        if (entry.id === vm.model.id) {
          isExist = true;
        }
      });

      if (isExist) return;

      this.dataSubAspec.items.push({
        id: this.model.id,
        code: this.model.code,
        name: this.model.name,
        description: this.model.description
      });
      this.model = null;
      this.search = null;
    },
    onClearAutoComplete: function() {
      this.model = null;
      this.entries = [];
      this.search = null;
      this.isLoading = false;
    },
    dialogClose: function() {
      const vm = this;
      ApiService.post("DataSubAspec/GetDataQuestionByDataSubAspec", {
        DataSubAspecId: vm.data.dataSubAspecId
      })
        .then(response => {
          vm.dataQuestion.items = response.data;
        })
        .catch(() => {});
    }
  }
};
</script>
<style lang="stylus" scoped>
.table-header /deep/ {
  thead {
    background-color: black;
  }
}

.media-menu {
  min-width: 260px;
  border-right: 1px solid #eee;
  min-height: calc(100vh - 50px - 64px);
}

.media-detail {
  min-width: 300px;
  border-left: 1px solid #eee;
}
</style>
